export const css = {
	root: 'bIRJvjRG',
	' _key': 'certwise-theme/certwise/backview/backview'
};

export default css;
